import G6 from '@antv/g6';
import {memo, useEffect, useMemo, useRef, useState} from "react";
import CourseDrawer from "../ShowCase/CourseDrawer";

const CourseDiagram = memo(({data}) => {

    const { courses, skills, relations } = data;

    const ref = useRef(null);

    const [openDrawer, setOpenDrawer] = useState(false);
    const [openingCourseId, setOpeningCourseId] = useState(null);

    let graph = null;

    const nodes = useMemo(() => {
        return [
            ...courses.map((node, index) => {
                return {
                    id: `course${node.id}`,
                    label: node.name,
                    description: node.short_description,
                    x: 750,
                    y: (index + 1) * 200 + 50,
                    style: {
                        cursor: 'pointer'
                    }
                }
            }),
            ...skills.map((node, index) => {
                return {
                    id: `skill${node.id}`,
                    label: node.name,
                    description: node.short_description,
                    x: 250,
                    y: index * 100 + 50,
                }
            })
        ];
    }, [courses, skills])
    const edges = useMemo(() => {
        return [...relations.map((relation) => {
            return {
                source: `skill${relation.skill}`,
                target: `course${relation.course}`,
                type: 'can-running'
            };
        })]
    }, [relations]);

    useEffect(() => {

        const lineDash = [4, 2, 1, 2];

        G6.registerEdge(
            'can-running',
            {
                setState(name, value, item) {
                    const shape = item.get('keyShape');
                    if (name === 'running') {
                        if (value) {
                            let index = 0;
                            shape.animate(
                                () => {
                                    index++;
                                    if (index > 9) {
                                        index = 0;
                                    }
                                    return {
                                        lineDash,
                                        lineDashOffset: -index,
                                    };
                                },
                                {
                                    repeat: true,
                                    duration: 3000,
                                },
                            );
                        } else {
                            shape.stopAnimate();
                            shape.attr('lineDash', null);
                        }
                    }
                },
            },
            'cubic-horizontal',
        );

        const container = ref.current;
        if(!graph)
            graph = new G6.Graph({
                container: container,
                width: container.scrollWidth,
                height: 1000,
                defaultNode: {
                    shape: 'modelRect',
                    size: [220, 80],
                    style: {
                        radius: 5,
                        stroke: '#ff850b',
                        fill: '#ffffff',
                        lineWidth: 1,
                        fillOpacity: 1,
                    },
                    labelCfg: {
                        style: {
                            fill: '#595959',
                            fontSize: 14
                        },
                        offset: 30
                    },
                    preRect: {
                        show: false,
                        width: 4,
                        fill: '#ff850b',
                        radius: 2
                    },
                    linkPoints: {
                        top: false,
                        right: false,
                        bottom: false,
                        left: false,
                        size: 3,
                        lineWidth: 1,
                        fill: '#72CC4A',
                        stroke: '#72CC4A'
                    },
                    logoIcon: {
                        show: true,
                        x: 0,
                        y: 0,
                        img: 'https://gw.alipayobjects.com/zos/basement_prod/4f81893c-1806-4de4-aff3-9a6b266bc8a2.svg',
                        width: 16,
                        height: 16,
                        offset: 0
                    },
                    stateIcon: {
                        show: false,
                    },
                },
                defaultEdge: {
                    style: {
                        stroke: '#b5b5b5',
                    },
                },
                modes: {
                    default: [
                        'drag-node',
                        'drag-canvas',
                        'activate-relations',
                        'zoom-canvas'
                    ],
                },
                nodeStateStyles: {
                    active: {
                        opacity: 1,
                    },
                    inactive: {
                        opacity: 0.1
                    }
                },
                fitCenter: true,
            });
        graph.data({ nodes: [...nodes], edges: [...edges] });
        graph.render();
        graph.fitView();

        graph.on('node:mouseenter', (ev) => {
            const node = ev.item;
            const edges = node.getEdges();
            edges.forEach((edge) => graph.setItemState(edge, 'running', true));
        });
        graph.on('node:mouseleave', (ev) => {
            const node = ev.item;
            const edges = node.getEdges();
            edges.forEach((edge) => graph.setItemState(edge, 'running', false));
        });
        graph.on('node:click', ev => {
            const item = ev.item;
            if (item) {
                if(item.getID().includes('course')) {
                    let itemId = item.getID().replace('course', '')
                    setOpeningCourseId(itemId);
                    setOpenDrawer(true);
                    // console.log(itemId)
                }
            }
        });

    }, [edges, nodes])

    return <>
        <div ref={ref} />
        <CourseDrawer
            courseId={openingCourseId}
            visible={openDrawer}
            onClose={() => { setOpenDrawer(false)}}
        />
    </>;

})

export default CourseDiagram;
